{
  "common": {
    "ok": "OK 🇯🇵",
    "cancel": "Cancel 🇯🇵",
    "back": "Back 🇯🇵",
  }
}
